<script>
import Component from '~/sites/soh/pages/register'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/registrovat',
      en: '/register',
      sk: '/registrovat',
    },
  },
}
</script>
